// MyGoogleMaps.js
import React, { Component } from "react";

import GoogleMapReact from "google-map-react";

import styled from "styled-components";

import AutoComplete from "./Autocomplete";
import Marker from "./Marker";

const Wrapper = styled.main`
  width: 100%;
  height: 100%;
`;

class MyGoogleMap extends Component {
  state = {
    mapApiLoaded: false,
    mapInstance: null,
    mapApi: null,
    geoCoder: null,
    places: [],
    center: [],
    zoom: 9,
    address: "",
    address_line: "",
    state: "",
    country: "",
    city: "",
    zip_code: "",
    draggable: true,
    lat: null,
    lng: null,
  };

  componentWillMount() {
    this.setCurrentLocation();
  }

  onMarkerInteraction = (childKey, childProps, mouse) => {
    this.setState({
      draggable: false,
      lat: mouse.lat,
      lng: mouse.lng,
    });
  };
  onMarkerInteractionMouseUp = (childKey, childProps, mouse) => {
    this.setState({ draggable: true });
    this._generateAddress();
  };

  _onChange = ({ center, zoom }) => {
    this.setState({
      center: center,
      zoom: zoom,
    });
  };

  _onClick = (value) => {
    this.setState({
      lat: value.lat,
      lng: value.lng,
    });
  };

  apiHasLoaded = (map, maps) => {
    this.setState({
      mapApiLoaded: true,
      mapInstance: map,
      mapApi: maps,
    });

    this._generateAddress();
  };

  addPlace = (place) => {
    this.setState({
      places: [place],
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    });
    this._generateAddress();
  };

  _generateAddress() {
    const { mapApi } = this.state;

    const geocoder = new mapApi.Geocoder();

    geocoder.geocode(
      { location: { lat: this.state.lat, lng: this.state.lng } },
      (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            const address_components = results[0]?.address_components;
            console.log("address_components", address_components);
            let new_address_line = "";
            const updateState = { address: results[0].formatted_address };
            for (let i = 0; i < address_components.length; i++) {
              let dt = address_components[i];
              if (dt.types.indexOf("country") !== -1) {
                if (dt.long_name == "Singapore") {
                  updateState.country = "Singapore";
                } else if (dt.long_name == "Indonesia") {
                  updateState.country = "Indonesia";
                } else if (dt.long_name == "Malaysia") {
                  updateState.country = "Malaysia";
                }
              }
              if (dt.types.indexOf("administrative_area_level_1") !== -1) {
                updateState.state = dt.long_name;
              }
              if (dt.types.indexOf("postal_code") !== -1) {
                updateState.zip_code = dt.long_name;
              }
              if (dt.types.indexOf("locality") !== -1) {
                updateState.city = dt.long_name;
              }
              if (
                dt.types.indexOf("subpremise") !== -1 ||
                dt.types.indexOf("premise") !== -1 ||
                dt.types.indexOf("neighborhood") !== -1 ||
                dt.types.indexOf("sublocality_level_2") !== -1 ||
                dt.types.indexOf("sublocality_level_1") !== -1 ||
                dt.types.indexOf("route") !== -1
              ) {
                new_address_line += dt.long_name + " ";
              }
              updateState.address_line = new_address_line;
            }
            this.zoom = 12;
            this.setState(updateState, () =>
              this.props.mapChangeHandler(this.state)
            );
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      }
    );
  }

  // Get Current Location Coordinates
  setCurrentLocation() {
    if (this.props?.location?.lat && this.props?.location?.lng) {
      this.setState(this.props?.location);
    } else if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.setState({
          center: [position.coords.latitude, position.coords.longitude],
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }
  }

  render() {
    const { places, mapApiLoaded, mapInstance, mapApi } = this.state;

    return (
      <Wrapper>
        {mapApiLoaded && (
          <div>
            <AutoComplete
              map={mapInstance}
              mapApi={mapApi}
              addplace={this.addPlace}
            />
          </div>
        )}
        <GoogleMapReact
          center={this.state.center}
          zoom={this.state.zoom}
          draggable={this.state.draggable}
          onChange={this._onChange}
          onChildMouseDown={this.onMarkerInteraction}
          onChildMouseUp={this.onMarkerInteractionMouseUp}
          onChildMouseMove={this.onMarkerInteraction}
          onChildClick={() => console.log("child click")}
          onClick={this._onClick}
          bootstrapURLKeys={{
            key: "AIzaSyB0B8ctcacMe3ycdC_lVGp5Xnu7_BA4jyM",
            // libraries: ["places", "geometry"],
            libraries: ["places"],
          }}
          options={{
            fullscreenControl: false,
          }}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => this.apiHasLoaded(map, maps)}
        >
          <Marker
            text={this.state.address}
            lat={this.state.lat}
            lng={this.state.lng}
          />
        </GoogleMapReact>

        {/* <div className="info-wrapper">
          <div className="map-details">
            Latitude: <span>{this.state.lat}</span>, Longitude:{" "}
            <span>{this.state.lng}</span>
          </div>
          <div className="map-details">
            Zoom: <span>{this.state.zoom}</span>
          </div>
          <div className="map-details">
            Address: <span>{this.state.address}</span>
          </div>
        </div> */}
      </Wrapper>
    );
  }
}

export default MyGoogleMap;
